import { render } from "./AgeVerification.vue?vue&type=template&id=2766edce&scoped=true"
import script from "./AgeVerification.vue?vue&type=script&lang=js"
export * from "./AgeVerification.vue?vue&type=script&lang=js"

import "./AgeVerification.vue?vue&type=style&index=0&id=2766edce&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2766edce"]])

export default __exports__